if (!customElements.get('product-sticky')) {
  class ProductSticky extends Product {
    constructor() {
      super();

      this.variantPriceEls = Array.from(this.querySelectorAll('.js-variant-price'));
      this.submitBtn = this.querySelector('.js-submit-btn');
      this.selectOptionTags = this.querySelectorAll('.js-selects option');
      this.selectTag = this.querySelector('.js-selects');
      this.mediaContainer = this.querySelector('.pdp-sticky__media'); 

      if (this.variantPriceEls.length && this.submitBtn) this.bindEvents();

      this.syncCurrentVariant = void 0;
    }

    connectedCallback() {
      requirejs(['pubsub'], () => {
        this.syncCurrentVariant = window.subscribeEvent(
          window.PUB_SUB_EVENTS.syncCurrentVariant,
          ({ source, data }) => {
            if (source == 'product-page')
              this.catchOnVariantChangeOnMainProduct(data?.currentVariant);
          }
        );
      })
    }

    bindEvents() {
      this.catchFixedOnScroll();
      this.setDefaultVariant();
      this.handleOnChange();
      this.submitForm();
    }

    catchFixedOnScroll() {
      const triggerElement = document.querySelector('.pdp__information');
      const chatButton = document.querySelector('#custom-chat-button');
    
      if (!triggerElement) return;

      let triggerElementTop = window.scrollY + triggerElement.getBoundingClientRect().top;

      if (window.scrollY >= triggerElementTop){
        if (chatButton) chatButton.style.bottom = '12rem';
        this.classList.add('is-fixed');
      }
      else {
        if (chatButton) chatButton.style.bottom = '1rem';
        this.classList.remove('is-fixed');
      } 

      window.addEventListener('resize', ()=>{
        triggerElementTop = window.scrollY + triggerElement.getBoundingClientRect().top;
      })
      window.addEventListener('scroll', () => {
        if (window.scrollY >= triggerElementTop){
          if (chatButton) chatButton.style.bottom = '12rem';
          this.classList.add('is-fixed');
        }
        else {
          if (chatButton) chatButton.style.bottom = '1rem';
          this.classList.remove('is-fixed');
        }       
      })
    }

    catchOnVariantChangeOnMainProduct(currentVariant) {
      if (!currentVariant) return;

      this.selectOptionTags.forEach((currentOption) => {
        if (currentOption.value == currentVariant.id) this.updateContent(currentOption);
      });
    }

    handleOnChange() {
      this.addEventListener('change', (event) => {
        event.preventDefault();

        const selectTag = event.target;
        const selectedOption = selectTag.options[selectTag.selectedIndex];
        const variantId = selectedOption.value;

        this.updateContent(selectedOption);

        window.publishEvent(window.PUB_SUB_EVENTS.syncCurrentVariant, {
          source: 'product-sticky',
          data: { currentVariantId: variantId }
        });
      });
    }

    updateContent(selectedOption) {
      const priceAttr = selectedOption.getAttribute('data-price') ?? selectedOption.dataset.price ?? '';
      if (priceAttr && this.variantPriceEls && this.variantPriceEls.length) {
        this.variantPriceEls.forEach(el => { el.textContent = priceAttr; });
      }

      const variantImageUrl = selectedOption.dataset.image || selectedOption.getAttribute('data-image');
      if (variantImageUrl && this.mediaContainer) {
        const imgElement = this.mediaContainer.querySelector('img');
        if (imgElement) {
          imgElement.src = variantImageUrl;
          imgElement.srcset = variantImageUrl;
        }
      }
 
      if (selectedOption.dataset.available == 'false')
        this.submitBtn.setAttribute('disabled', 'disabled');
      else this.submitBtn.removeAttribute('disabled');
 
      if (selectedOption.value) this.currentVariantId = selectedOption.value;
 
      selectedOption.selected = true;
    }

    setDefaultVariant() {
      this.currentVariantId = this.dataset.defaultVariantId;
    }

    async submitForm() {
      if (!this.currentVariantId) this.submitBtn.setAttribute('disabled', 'disabled');

      this.submitBtn.addEventListener('click', async () => {
        if (!this.currentVariantId) return;

        let mainData = {
          items: [
            {
              id: this.currentVariantId,
              quantity: 1
            }
          ],
          sections: 'cart-drawer',
          sections_url: window.location.pathname
        };

        this.submitBtn.classList.add('is-loading');

        await fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(mainData)
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) return this.handleErrorMessage(response.description);

            publishEvent(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              data: response
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitBtn.classList.remove('is-loading');
            this.submitBtn.removeAttribute('disabled');
          });
      });
    }

    handleErrorMessage(errorMessageText = false) {
      this.errorMessage = this.errorMessage || this.querySelector('.js-error-message');

      if (errorMessageText) {
        this.errorMessage.classList.remove('hidden');
        this.errorMessage.textContent = errorMessageText;

        setTimeout(() => {
          this.errorMessage.classList.add('hidden');
        }, 5000);
      } else this.errorMessage.classList.remove('hidden');
    }
  }

  customElements.define('product-sticky', ProductSticky);
}